import { useNavigate } from "react-router";

import { DatetimeToDate, programMonths } from "../../utils/datetime.js";

import { PatientAvatar, Status } from './component.js';

function PatientCard(props) {
  const { patient, link, compact, activeProject, hideCheckin } = props;

  const navigate = useNavigate();

  function patientField(patient, field) {
    return patient.fields?.find(f => f.code === field)?.answers?.[0] || null;
  }

  function alignmentMonths(patient) {
    if (!patient.alignmentDate) return null;
    return programMonths(DatetimeToDate(patient.alignmentDate));
  }

  function renderLifecycleStage(patient) {
    const title = activeProject?.templateName;
    switch (patient.lifecycleStage) {
      case "PRE_ALIGNMENT":
        return <span className="typo-normal-150 text-muted">{title || 'Pre-Alignment'}</span>;
      case "POST_ALIGNMENT_NEW":
      case "POST_ALIGNMENT_EST":
        return <span className="typo-normal-150 text-muted">{title || 'Post-Alignment'}</span>;
      case "UNALIGNED":
        return <span className="typo-normal-150 text-muted">{title || 'Unaligned'}</span>;
      default:
        return null;
    }
  }

  function renderPatientStatus(patient) {
    if (patient.statusType === "DRAFT") {
      return <Status color={'blue'} muted={true} text={'Draft'} />;
    }
    if (patient.statusType === "ACTIVE") {
      if (!hideCheckin && activeProject?.monthlyCheckinRequired && activeProject?.monthlyCheckinComplete && activeProject?.monthlyCheckinDate) {
        return <Status color={'green'} muted={true} text={`Monthly check-in at ${activeProject.monthlyCheckinDate}`} />;
      }
      if (patient.missingRequiredActionCount > 0) {
        return null;
      }
      return <div className="status invisible" style={{width: 0, padding: 0, overflow: 'hidden'}} />;
    }
    if (patient.statusType === "ARCHIVED") {
      return <Status color={'grey'} muted={true} text={'Archived'} />;
    }
    if (patient.statusType === "CANCELED") {
      return <Status color={'orange'} muted={true} text={'Unaligned'} />;
    }
    return null;
  }

  return (
    <div onClick={() => link ? navigate(`/patient/${patient.id}/card`) : null} className="card clickable mb-2">
      <div className="card-content sm">
        <div className="row align-items-center">
          <div className={compact ? "col-xs-8" : "col-xs-4"}>
            <div className="d-flex justify-content-start align-items-center">
              <PatientAvatar id={patient.id} alt="logo" style={compact ? {height: 30, width: 30} : {height: 50, width: 50}} />
              <div className={compact ? "ms-2" : "ms-4"}>
                <div className={compact ? "typo-strong-225" : "typo-strong-200"}>{patient.firstName} {patient.middleName ? patient.middleName + " " : ""}{patient.lastName}</div>
                {!compact && (
                  <div className="typo-normal-150">{patientField(patient, "medicareBeneficiaryIdentifier")}</div>
                )}
              </div>
            </div>
          </div>
          {!compact && (
            <div className="col-xs-4">
              <div className="typo-normal-150">{patientField(patient, "phone")}</div>
              <div className="typo-normal-150">{patientField(patient, "email")}</div>
            </div>
          )}
          <div className="col-xs-4 text-end">
            {patient.missingRequiredActionCount > 0 && (
              <Status
                color={'red'}
                muted={true}
                text={patient.missingRequiredActionCount === 1 ? 'Missing required action' : `${patient.missingRequiredActionCount} missing required actions`}
              />
            )}
            {renderPatientStatus(patient)}
            {!compact && patient.statusType === "ACTIVE" && renderLifecycleStage(patient) && (
              <div className="mt-1">{renderLifecycleStage(patient)}</div>
            )}
            {!compact && patient.statusType === "ACTIVE" && alignmentMonths(patient) !== null && (
              <div className="typo-normal-150 text-muted mt-1">{alignmentMonths(patient)} month{alignmentMonths(patient) === 1 ? "" : "s"} in program</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PatientCard;
